import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Form, Input, Select, Popover, Spin, Space } from 'antd';
import { SearchOutlined, RedoOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import { useLocation } from 'react-router-dom';
import SelectProgModal from './selectProgModal';
import trans from './jobManagementReportTranslation';
import './jobManagementReport.css';
import { partnerCheckLogin } from '../newMain/partnerMain';

const { Option } = Select;

const PartnerJobManagementReport = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const jobTypeId = Form.useWatch('jobType', form);
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("");
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState(useLocation().model ?? {});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);

    const [isSearchProgModal, setIsSearchProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});
    const [jobPostStatus, setJobPostStatus] = useState("");
    const [jobPostModel, setJobPostModel] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);
    const [studentTable, setStudentTable] = useState([]);
    const [jobTypeList, setJobTypeList] = useState([]);
    const [jobTypeCode, setJobTypeCode] = useState("");
    const [radioGroups, setRadioGroups] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [searchProgModel, setSearchProgModel] = useState({});

    const tableColumns = {
        jobTitle: "job_title",
        vacancies: "vacancies",
    }

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        search(pageSize, 1, "N");
    }, []);

    useEffect(() => {
        search(pageSize, 1, "N");
    }, [Config.programmeInfo.progCode]);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.partnerId = Config.partnerInfo?.partnerId
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("jobPost/searchReport", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        setJobPostModel({});
        setCohortProgModel({});
        setJobPostStatus("");
        setStudentTable([]);
        setIsDisabled(false);
        setJobTypeCode("");
        setRadioGroups("");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    

    useEffect(() => {
        setJobTypeCode("");
        if (jobTypeId) {
            let model = jobTypeList.find((item) => item.paramId === jobTypeId);
            setJobTypeCode(model?.code ?? "");
        }
    }, [jobTypeId]);

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "Job Posting Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "jobPost/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth4',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: trans.jobTitle[Config.backLang],
            dataIndex: 'jobTitle',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        {
            title: trans.programmeTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth7',
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        {
            title: trans.industrialPartner[Config.backLang],
            dataIndex: 'companyName',
            className: 'tableWidth6',
        },
        {
            title: trans.jobPostStatus[Config.backLang],
            dataIndex: 'jobPostStatus',
            className: 'tableWidth6',
            render: (text) => ContextHandler.getMapValue('jobPostStatusMap', text)
        }, 
        {
            title: 'Date IP Submits Job Post to MC',
            dataIndex: 'submitDate',
            className: 'tableWidth6',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: 'Total Number of Job Applications',
            dataIndex: 'jobApplyCount',
            className: 'tableWidth6',
        },
        {
            title: 'Total Offer Accepted by Student',
            dataIndex: 'offerAcceptedCount',
            className: 'tableWidth7',
        },
        {
            title: 'Assigned Students',
            dataIndex: 'assignedStudents',
            className: 'tableWidth4',
        },
        {
            title: trans.positionType[Config.backLang],
            dataIndex: 'positionTypeVal',
            className: 'tableWidth4',
        },
        {
            title: trans.jobType[Config.backLang],
            dataIndex: 'jobTypeVal',
            className: 'tableWidth6',
        },  
        {
            title: trans.salary[Config.backLang],
            dataIndex: 'salaryRangeFrom',
            className: 'tableWidth3',
            render: (text, record) => <div>
               {text && (Base.numberFormat(text) +" ~ "+ Base.numberFormat(record.salaryRangeTo))}
            </div>
        },
        {
            title: trans.unit[Config.backLang],
            dataIndex: 'unitVal',
            className: 'tableWidth4',
        },  
        {
            title: 'Est # Days/Wk',
            dataIndex: 'estimatedNoOfDaysAWeek',
            className: 'tableWidth5',
        },  
        {
            title: 'Est # Hrs/Wk',
            dataIndex: 'estimatedNoOfHoursAWeek',
            className: 'tableWidth5',
        },  
        {
            title: 'Expected Commence Date',
            dataIndex: 'expCommenceDate',
            className: 'tableWidth6',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: 'Expected End Date',
            dataIndex: 'expEndDate',
            className: 'tableWidth4',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: trans.lastApplyDate[Config.backLang],
            dataIndex: 'lastApplyDate',
            className: 'tableWidth4',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: trans.vacancies[Config.backLang],
            dataIndex: 'vacancies',
            className: 'tableWidth4',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'vacancies') },
        },      
        {
            title: trans.workLocation[Config.backLang],
            dataIndex: 'workLocVal',
            className: 'tableWidth4',
        },
    ];

    const columnsTwo = [
        {
            title: trans.studentID[Config.backLang],
            dataIndex: 'studentAcctId',
            className: 'tableWidth30',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: trans.studentName[Config.backLang],
            dataIndex: 'firstName',
            className: 'tableWidth35',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'firstName') },
            render: (text, record) => <div>{text + " " + record.lastName}</div>
        },
        {
            title: trans.email[Config.backLang],
            dataIndex: 'email',
            className: 'tableWidth35',
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 120,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record, index) => <div className='operation'>
                <div className='sysDelete' onClick={(e) => studentDelete(index, e, record)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
            </div>
        },
    ]
    if (flag !== "add" && flag !== "edit") {
        columnsTwo.splice(3, 1)
    }
    const closeSearchProgModal = (flag, cohortProg) => {
        if(flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
            setSearchProgModel(cohortProg);
        }
        setIsSearchProgModal(false);
    }
    /*eslint-enable*/

    return (
        <div id="container" className="websiteTemplate jobManagementReport">
            <div className='title' style={{fontSize:'32px'}}>
                <div>Job Posting Report</div>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                            <div className='sysSearchRow sysSearchBox' style={{paddingTop:' 12px'}}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobTitle[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.jobTitle || ''}
                                                placeholder={trans.jobTitle[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('jobTitle', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.programme[Config.backLang]}</div>
                                        <div className="sysButtonSearchInput">
                                            <Input type="text" value={searchModel.progCode || ''} disabled
                                                placeholder={trans.programme[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('progCode', e.target.value)} />
                                        </div>
                                        <Button className="sysBtn btnBlue" onClick={() => { setIsSearchProgModal(true) }}>Select</Button>
                                        <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobPostStatus[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className='sysSelect'
                                                value={searchModel.jobPostStatus || ''}
                                                onChange={(value) => searchChange('jobPostStatus', value)}>
                                                <Option value=''></Option>
                                                {context.jobPostStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)}  icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                {tables.length == 0 ? null :
                                    <>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel}  icon={<DownloadOutlined />}>Export</Button>
                                    </>
                                }
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 2500 }}
                                    rowKey="jobId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                </Spin>
            </div>
            {isSearchProgModal && <SelectProgModal onClose={closeSearchProgModal} progModel={searchProgModel}/> }
        </div>
    )

}

export default PartnerJobManagementReport;